var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_5412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20942 16.3378C6.94093 16.0693 6.91856 15.6479 7.14229 15.354L7.20942 15.2772L17.816 4.67057C18.1089 4.37768 18.5838 4.37768 18.8767 4.67057C19.1452 4.93906 19.1675 5.36046 18.9438 5.65443L18.8767 5.73123L8.27008 16.3378C7.97718 16.6307 7.50231 16.6307 7.20942 16.3378Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8103 5.96872C9.39609 5.96962 9.05958 5.63455 9.05869 5.22034C9.05787 4.84379 9.33471 4.53145 9.69626 4.4771L9.80707 4.46873L18.3447 4.45034C18.7224 4.44953 19.0352 4.72797 19.0883 5.09073L19.0963 5.20189L19.0786 13.7402C19.0778 14.1544 18.7413 14.4895 18.3271 14.4887C17.9505 14.4879 17.6393 14.2097 17.5865 13.8479L17.5786 13.7371L17.5943 5.95193L9.8103 5.96872Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_5412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.12793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.33ceac6ff778591f04f365965e405dfc.svg";
export { ForwardRef as ReactComponent };